import { Globe, MapPin, Share2, Inbox, Zap, Search, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    id: "website-design",
    icon: Globe,
    badge: "Digital Foundation",
    title: "Website Design & Launch",
    desc: "Fast, professional, mobile-friendly websites designed to convert visitors into enquiries.",
  },
  {
    id: "google-visibility",
    icon: MapPin,
    badge: "Local Search",
    title: "Google Business & Local Visibility",
    desc: "Improve how customers discover your business through Google and local search.",
  },
  {
    id: "social-setup",
    icon: Share2,
    badge: "Brand Presence",
    title: "Social Business Setup",
    desc: "Professional Facebook and Instagram business presence with consistent branding.",
  },
  {
    id: "lead-capture",
    icon: Inbox,
    badge: "Enquiry Systems",
    title: "Lead Capture Systems",
    desc: "Contact forms, quote requests, booking systems, WhatsApp and other enquiry channels.",
  },
  {
    id: "business-automation",
    icon: Zap,
    badge: "Smart Workflows",
    title: "Business Automation",
    desc: "Automate enquiry responses, follow-ups, notifications and repetitive customer communication.",
  },
  {
    id: "local-seo",
    icon: Search,
    badge: "Organic Growth",
    title: "Local SEO & Search Setup",
    desc: "Technical and on-page optimisation to help search engines understand and discover your business.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28">
      <div className="section-shell">
        <Reveal>
          <p className="micro-label">What We Do</p>
          <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white max-w-xl">
              Everything a local business needs for a professional online presence
            </h2>
            <p className="text-sm sm:text-base text-slate-400 max-w-md leading-relaxed">
              Six connected services that help you get found, capture enquiries and save time on
              repetitive communication.
            </p>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={0.06 * (i % 3)}>
              <article
                data-testid={`service-card-${s.id}`}
                className="card-hover group relative h-full rounded-2xl border border-sky-500/12 bg-navy-900/70 p-7 flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl border border-sky-500/25 bg-sky-500/10 text-sky-400">
                    <s.icon size={22} strokeWidth={1.8} />
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">{s.badge}</span>
                </div>
                <h3 className="mt-6 font-heading text-lg sm:text-xl font-bold text-white tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 flex-1">{s.desc}</p>
                <a
                  href="#contact"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-sky-400 hover:text-sky-300 transition-colors"
                >
                  Enquire about this <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
